var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7463 0.824738C10.6698 0.824738 9.79688 1.71038 9.79688 2.80254V16.4516L10.7718 16.075V2.86076C10.7718 2.31473 11.208 1.82272 11.7463 1.82272C12.2845 1.82272 12.721 2.31473 12.721 2.86076V16.075L13.6954 16.4516V2.80254C13.6954 1.71034 12.8227 0.824738 11.7463 0.824738Z",
    fill: "#1E2447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7207 15.5005V16.5392C13.7517 16.9378 14.4841 17.9498 14.4841 19.1355C14.4841 20.6702 13.2588 21.914 11.746 21.914C10.2339 21.914 9.00782 20.6702 9.00782 19.1355C9.00782 17.9497 9.74051 16.9378 10.7715 16.5392V15.5005C9.19358 15.9348 8.0332 17.3973 8.0332 19.1358C8.0332 21.2167 9.69537 22.9031 11.7461 22.9031C13.7971 22.9031 15.4587 21.2167 15.4587 19.1358C15.4587 17.3974 14.2985 15.9349 12.7207 15.5005Z",
    fill: "#1E2447"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2213 9.67784C12.2213 9.40628 12.0124 9.18655 11.7552 9.18655H11.7356C11.4785 9.18655 11.2696 9.40632 11.2696 9.67784V17.0463C10.3097 17.2754 9.58984 18.1805 9.58984 19.2611C9.58984 20.5141 10.5568 21.5334 11.7452 21.5334C12.9341 21.5334 13.9011 20.5141 13.9011 19.2611C13.9011 18.1804 13.1813 17.2756 12.2213 17.0463V9.67784Z",
    fill: "#1E2447"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/Temperature.3010cf41.svg";
export { ForwardRef as ReactComponent };